<template>
  <div class="line">
    <Header :present-page="presentPage" />
    <a-row class="top">
      <a-col class="ipt">
        <span>设备名称</span>
        <a-input
          v-model:value="searchData.deviceName"
          placeholder="请输入"
        />
        <!-- <a-select
          ref="select"
          style="width: 236px"
          v-model:value="searchData.deviceName"
        >
          <a-select-option
            :value="item.deviceName"
            :key="item"
            v-for="(item, i) in deviceLists"
          >{{item.deviceName}}</a-select-option>
        </a-select> -->
        <a-divider type="vertical" />
      </a-col>
      <a-col class="ipt">
        <span>预警时间</span>
        <a-range-picker
          v-model:value="time"
          @change="rangePicker"
          showTime
        />
      </a-col>
      <a-col class="operate">
        <a-button
          type="primary"
          @click="search"
        >查询</a-button>
        <a-button
          type="default"
          @click="reset"
        >重置</a-button>
      </a-col>
    </a-row>
    <a-row
      class="a-row"
      justify="space-between"
      align="middle"
    >
      <a-col>预警信息列表
        <a-button
          type="primary"
          class="update"
          @click="init"
          :loading="loading"
        >刷新</a-button>
      </a-col>
      <a-col>
        <a-button
          type="primary"
          class="export"
          @click="download"
        >导出</a-button>
      </a-col>
    </a-row>
    <a-table
      rowKey="id"
      :pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      @change="change"
    >
      <template #action="{record}">
        <span v-if="record.isRead == 0">已处理</span>
        <a-button
          v-else
          class="alter"
          @click="manage(record)"
        >处理</a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import { alarmList, alarmhandle, alarmList2 } from "@/api/warning/warning.js";
import { deviceList } from "@/api/project/project.js";

export default {
  name: "Message",
  components: {
    Header,
  },
  data() {
    return {
      presentPage: '',
      searchData: {
        deviceName: '',
        startTime: '',
        endTime: '',
        export: false
      },
      time: [],
      deviceLists: [],
      query: {
        pageNum: 1,
        pageSize: 10
      },
      delQuery: {
        uuid: ''
      },
      pagination: {
        size: 'small',
        showSizeChanger: true,
        showQuickJumper: true,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
      },
      loading: false,
      columns: [
        {
          title: '线路名称',
          dataIndex: 'lineName',
        },
        {
          title: '桥梁名称',
          dataIndex: 'bridgeName',
        },
        {
          title: '设备ID',
          dataIndex: 'deviceUuid',
        },
        {
          title: '设备名称',
          dataIndex: 'deviceName',
        },
        {
          title: '警报名称',
          dataIndex: 'alarmName',
        },
        {
          title: '警报信息',
          dataIndex: 'describe',
          ellipsis: true,
        },
        {
          title: '预警等级',
          dataIndex: 'level',
        },
        {
          title: '当前阈值',
          dataIndex: 'nowThreshold',
        },
        {
          title: '报警数值',
          dataIndex: 'nowValue',
        },
        {
          title: '预警时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          slots: {
            customRender: 'action',
          },
        },
      ],
      dataSource: [],
    }
  },
  mounted() {
    this.presentPage = this.$route.query.name
    this.init()
    deviceList(this.query).then(res => { //设备列表
      if (res.code == 200) {
        this.deviceLists = res.data.list
      }
    }).catch(res => {
      console.log(res)
    });
  },
  methods: {
    rangePicker(value, dateString) {
      // console.log(value, dateString)
      this.searchData.startTime = dateString[0]
      this.searchData.endTime = dateString[1]
    },
    search() {
      this.query.filterDate = this.searchData
      this.init()
    },
    reset() {
      this.searchData.deviceName = ''
      this.searchData.startTime = ''
      this.searchData.endTime = ''
      this.time = []
      this.search()
    },
    init() {
      this.loading = true
      alarmList(this.query).then(res => { //预警信息列表
        if (res.code == 200) {
          this.dataSource = res.data.list
          this.pagination.total = res.data.total
          this.loading = false
        }
      }).catch(res => {
        console.log(res)
      });
    },
    download() {
      this.searchData.export = true
      this.query.filterDate = this.searchData
      alarmList2(this.query).then(res => { //预警信息列表
        if (this.searchData.export) {
          let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
          let downloadFilename = '预警信息' + new Date();//设置导出的文件名 
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            //兼容ie浏览器
            window.navigator.msSaveOrOpenBlob(blob, downloadFilename)
          } else {
            //谷歌,火狐等浏览器
            let url = window.URL.createObjectURL(blob);
            let downloadElement = document.createElement("a");
            downloadElement.style.display = "none";
            downloadElement.href = url;
            downloadElement.download = downloadFilename;
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(url);
          }
          this.$message.success('导出成功');
        }
      }).catch(res => {
        console.log(res)
      });
    },
    manage(record) {
      console.log(record)
      let ids = []
      ids.push(record.id)
      alarmhandle({ ids: ids }).then(res => { //预警信息处理
        if (res.code == 200) {
          record.isRead = 0
          this.$message.success('处理成功');
        }
      })
    },
    change(pagination) {
      console.log(pagination)
      this.query = {
        pageNum: pagination.current,
        pageSize: pagination.pageSize
      }
      this.init()
    }
  }
};
</script>
<style scoped>
.top {
  height: 76px;
  margin: 20px 30px 0;
  padding: 20px 30px;
  line-height: 36px;
  background: #fff;
}

.ipt {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: left;
}
.ipt span {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.ipt input {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ipt .ant-calendar-picker {
  margin-right: 20px;
}
.ant-divider-vertical {
  height: 22px;
  margin: 0 15px;
  background: #dddddd;
}
.ant-select :deep() .ant-select-selector {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item {
  height: 34px;
  line-height: 34px;
}
.ipt :deep() .ant-calendar-picker {
  width: 236px;
}
.ipt :deep() .ant-calendar-picker-input {
  width: 100%;
  height: 36px;
  border-radius: 6px;
}
.operate {
  text-align: left;
}
.operate button:nth-child(1) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.operate button:nth-child(2) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}
.add button {
  width: 80px;
  height: 36px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.update {
  margin-left: 20px;
  height: 36px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.export {
  width: 80px;
  height: 36px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.a-row {
  margin: 20px 30px 0;
  padding: 10px 20px;
  background: #fff;
}
.ant-table-wrapper {
  margin: 0 30px;
}
.ant-table-wrapper :deep() .ant-table-thead > tr > th,
.ant-table-wrapper :deep() .ant-table table {
  text-align: center;
}
.ant-table-wrapper .ant-btn {
  width: 66px;
  height: 24px;
  padding: 0;
  margin: 0 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  border-radius: 4px;
}
.alter {
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
}
.del {
  color: #ff4444;
  background: #fff;
  border: 1px solid #ff4444;
}
</style>
